import React, { Component, forwardRef } from "react";
import { FormControl, OverlayTrigger, Tooltip } from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import "../../../assets/css/orderItemCard.css";
import AsyncSelect from "react-select/lib/Async";

const ForwardedFormControl = forwardRef((props, ref) => (
  <input {...props} ref={ref} />
));
class OrderItemCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      selectedBatch: null,
    };
  }

  toggleExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  handleBatchSelect = (batch) => {
    this.setState({ selectedBatch: batch });
    if (this.props.onBatchSelect) {
      this.props.onBatchSelect(this.props.index, batch);
    }
  };

  handleQuantityChange = (batch, value) => {
    if (this.props.onQuantityChange) {
      this.props.onQuantityChange(this.props.index, batch, value);
    }
  };
  BatchNoOnchange = (e) => {
    const batchNo = e.target.value;
    console.log("Batch No Changed:", batchNo);
    if (batchNo !== "") {
      this.handleBatchNumber(batchNo);
    }
  };

  render() {
    const { item, index, onRemove, onCheck, isChecked } = this.props;
    const { isExpanded, selectedBatch } = this.state;

    console.log(isExpanded);

    return (
      <div className={`order-item-card ${isChecked ? "checked" : ""}`}>
        {/* Header Section */}
        <div className="order-item-header">
          <div className="header-left">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => onCheck(index)}
              className="item-checkbox"
            />
            <span className="item-number">{index + 1}</span>
            <span className="batch-number">
              {/* add input text field */}
              <ForwardedFormControl
                type="text"
                name="Batch No"
                placeholder="Batch No"
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e3e3e3",
                  borderRadius: "22px",
                  color: "#565656",
                  padding: " 8px 12px",
                  height: "40px",
                  boxShadow: "none",
                  width: "100%",
                }}
                // onChange={(e) => this.BatchNoOnchange(e)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.BatchNoOnchange(e);
                  }
                }}
                // value={poItem.barcode}
              />
            </span>
            <span className="item-name">
              <AsyncSelect
                className="react-select primary"
                classNamePrefix="react-select"
                name="description"
                value={this.props.selectedDescription || ""}
                onChange={(value) =>
                  this.props.onMedicineSelect &&
                  this.props.onMedicineSelect(value, index)
                }
                loadOptions={this.props.loadMedicationOptions}
                cacheOptions
                defaultOptions={false}
                placeholder="Medication"
                noOptionsMessage={() => "Type Item Name or Code or Barcode"}
              />
            </span>
          </div>
          <div className="header-right">
            <div className="price-info" style={{ margin: "-9px" }}>
              <label>Unit Price</label>
              <span>{item.unit_price || "0.00"}</span>
            </div>
            <div className="price-info">
              {/* <label>Sale Price</label> */}
              <span>
                <FormControl
                  type="text"
                  value={selectedBatch ? selectedBatch.sale_price : ""}
                  placeholder="Sale Price"
                  style={{ borderRadius: "22px" }}
                  //   onClick={() => this.setState({ showBatchModal: true })}
                />
              </span>
            </div>
            <div className="price-info">
              <label>Total Qty</label>
              <span>{item.total_quantity || 0}</span>
            </div>
            <button className="remove-btn" onClick={() => onRemove(index)}>
              X
            </button>
          </div>
        </div>

        {/* Toggle Bar */}
        <div className="order-item-toggle">
          {isExpanded ? (
            <button
              type="button"
              className="toggle-btn hide"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                this.toggleExpand();
              }}
            >
              Hide
            </button>
          ) : (
            <button
              type="button"
              className="toggle-btn show"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                this.toggleExpand();
              }}
            >
              Show
            </button>
          )}
          <div className="item-info-row">
            <div className="item-info-field checkbox-field">
              <label>Available</label>
              <input
                type="checkbox"
                checked={!!item.available}
                readOnly
                disabled
              />
            </div>
            <div className="item-info-field checkbox-field">
              <label>Printable</label>
              <input
                type="checkbox"
                checked={!!item.printable}
                readOnly
                disabled
              />
            </div>
            <div className="item-info-field checkbox-field">
              <label>Claimable</label>
              <input
                type="checkbox"
                checked={!!item.claimable}
                readOnly
                disabled
              />
            </div>
            <div className="item-info-field checkbox-field">
              <label>Upseller</label>
              <input
                type="checkbox"
                checked={!!item.upseller}
                readOnly
                disabled
              />
            </div>
            <div className="item-info-field">
              <label>Placement</label>
              <span>{item.placement || "C2"}</span>
            </div>
            <div className="item-info-field">
              <label>Total Stock</label>
              <span>{item.total_stock || 178996}</span>
            </div>
            <div className="item-info-field">
              <label>Item Code</label>
              <span>{item.item_code || "F-004245"}</span>
            </div>
            <div className="item-info-field sub-total">
              <label>Sub Total</label>
              <span>{item.sub_total || "437.5"}</span>
            </div>
          </div>
        </div>

        {/* Expandable Content */}
        {isExpanded && (
          <div className="order-item-content">
            {/* Stock Availability Section */}
            <div className="stock-section">
              <div className="section-header">STOCK AVAILABILITY</div>
              <table className="stock-table">
                <thead>
                  <tr>
                    <th>Batch</th>
                    <th>Expiry</th>
                    <th>Available Qty</th>
                    <th>Location</th>
                    <th>Qty</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {item.stock_availability &&
                  item.stock_availability.length > 0 ? (
                    item.stock_availability.map((stock, idx) => (
                      <tr
                        key={idx}
                        className={stock.not_fifo ? "not-fifo" : ""}
                      >
                        <td>{stock.batch}</td>
                        <td>{stock.expiry}</td>
                        <td>{stock.available_qty}</td>
                        <td>{stock.location}</td>
                        <td>
                          <FormControl
                            type="number"
                            value={stock.qty || ""}
                            onChange={(e) =>
                              this.handleQuantityChange(stock, e.target.value)
                            }
                            className="qty-input"
                          />
                          {stock.not_fifo && (
                            <span className="not-fifo-badge">⚠ Not FIFO</span>
                          )}
                        </td>
                        <td>{stock.price || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        No stock available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Other Brand Section */}
            {item.other_brands && item.other_brands.length > 0 && (
              <div className="other-brand-section">
                <div className="section-header">OTHER BRAND</div>
                <table className="stock-table">
                  <thead>
                    <tr>
                      <th>Batch</th>
                      <th>Expiry</th>
                      <th>Available Qty</th>
                      <th>Location</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.other_brands.map((brand, idx) => (
                      <tr key={idx}>
                        <td>{brand.name}</td>
                        <td>{brand.expiry}</td>
                        <td>{brand.available_qty}</td>
                        <td>{brand.location}</td>
                        <td>{brand.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default OrderItemCard;
